<template>
  <div>
    <section class="section">
      <div class="container" style="padding-top: 20px;">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <menu-lateral></menu-lateral>
            <!--
            <div class="box-aside line-top">
              <ul class="list-group menu-aside">
                <li class="list-group-item "><a href="pedidos.html"><i class="fa fa-cutlery"></i> <span>Pedidos</span> <i class="fa fa-angle-right"></i></a></li>
                <li class="list-group-item">
                <a href="usuarios.html"><i class="fa fa-user"></i>  <span>Usuarios</span> <i class="fa fa-angle-right"></i></a>
                <ul class="subnav">
                  <li><a href="usuario_nuevo.html">Nuevo usuario</a></li>
                  <li><a href="usuario_invitar.html">Invitar usuarios</a></li>
                </ul>
                </li>
                <li class="list-group-item active"><a href="historial_empresa.html"><i class="fa fa-list"></i>  <span>Historial Empresa</span> <i class="fa fa-angle-right"></i></a></li>
                <li class="list-group-item"><a href="liquidaciones.html"><i class="fa fa-dollar"></i>  <span>Liquidaciones</span> <i class="fa fa-angle-right"></i></a></li>
              </ul>
            </div>
            -->
          </div>
          <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">

          <div class="row" style="margin-bottom:20px;">
            <div class="col-md-4">
              <ul class="breadcrumbs" style="position:initial; top:0px;">
                <li>Administración</li>
                <li><i class="fa fa-angle-right"></i></li>
                <li class="active">Historial Empresa</li>
              </ul>
            </div>
            <div class="col-md-8 text-right">
          <div  v-if="sucursales.length>1">
                      <b class="text-brand">Sucursal</b>
                      <div class="btn-group">
                        <button class="btn btn-brand dropdown-toggle" data-toggle="dropdown" id="dd1" aria-expanded="true">
                          {{sucursal.denominacion}}  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu super" aria-labelledby="dd1">
                          <li v-for="suc in sucursales">
                            <a href="" @click.prevent="cambiarSucursal(suc)">{{suc.denominacion}}</a>
                          </li>
                        </ul>
                      </div>
          </div>

            </div>
          </div>

            <div class="box-style line-top">
              <div class="box-header">
                <h2>HISTORIAL EMPRESA</h2>
              </div>
              <div class="box-body">
                <div class="table-header form smart-form">
                  <div class="row">
                    <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Desde <i class="fa fa-warning" title="La fecha desde no puede ser mayor a la fecha hasta" style="color: red;" v-if="hayConflictoDeFechas"></i></label>
                        <date-picker :max-date="new Date()" :default-date="filtros.fechaDesde" v-model="filtros.fechaDesde"></date-picker>
                      </div>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Hasta <i class="fa fa-warning" title="La fecha desde no puede ser mayor a la fecha hasta" style="color: red;" v-if="hayConflictoDeFechas"></i></label>
                        <date-picker :max-date="filtros.fechaHasta" v-model="filtros.fechaHasta" :default-date="filtros.fechaHasta"></date-picker>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group select2-plugin-lg">
                        <label>Empleado</label>
                        <select class="form-control select2" ref="slEmpleados" style="width:100%;" data-select2-container="big-text">
                          <option value="-1">Todos los usuarios</option>
                          <option v-for="usuario in usuarios" :value="usuario._id" :key="usuario._id">{{usuario.displayName}}</option>
                         </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="text-center center-block">
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green dropdown-toggle" data-toggle="dropdown" id="dd1" aria-expanded="true">
                          <i class="fa fa-print"></i> Imprimir  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dd1">
                          <li>
                            <a href="#" @click.prevent="onImprimirSeleccionados">Selección</a>
                          </li>
                          <li>
                            <a href="#" @click.prevent="onClickImprimirTodos">Todos</a>
                          </li>
                        </ul>
                      </div>
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green dropdown-toggle" id="dd2" data-toggle="dropdown" aria-expanded="false">
                          <i class="fa fa-file-excel-o"></i> Exportar  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu pull-right" role="menu" aria-labelledby="dd2">
                          <li>
                            <a href="#" @click.prevent="onClickExportar">Selección</a>
                          </li>
                          <li>
                            <a href="#" @click.prevent="onClickExportarTodas">Todos</a>
                          </li>
                        </ul>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="clear-sm"></div>
                <div class="table-container">
                  <!--
                  <div class="form-group">
                    <button type="button" class="btn btn-outline btn-sm download-selected" :class="{disabled: entregasSeleccionadas.length === 0}"><i class="fa fa-download"></i> DESCARGAR SELECCIONADOS{{entregasSeleccionadas.length}}</button>
                  </div>
                  -->
                  <table class="table table-hover table-stripped table-no-first-pad">
                    <thead>
                      <tr>
                        <th>
                          <button class="btn btn-xs btn-fill" @click.prevent="onClickSeleccionarTodos">
                            <i class="fa fa-check-square-o" aria-hidden="true"></i>
                          </button>
                        </th>
                        <th>Numero</th>
                        <th>Detalle</th>
                        <th>Total</th>
                        <th>Entrega</th>
                        <th>Para</th>
                        <th>Pedido por</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="entrega in entregasActivas" :key="entrega._id">
                        <td>
                          <div class="smart-form">
                            <label class="checkbox">
                              <input v-model="entrega.seleccionada" type="checkbox" class="download" />
                              <i></i>
                            </label>
                          </div>
                        </td>
                        <td>{{entrega.numero}}</td>
                        <td>{{entrega.platosSerialized}}</td>
                        <td class="text-right">{{entrega.montoTotal | formatearMoneda}}</td>
                        <td>{{entrega.fechaEntrega | formatearFecha}}</td>
                        <td><small>{{entrega.usuario.displayName}}</small></td>
                        <td><small>{{entrega.creador.displayName}}</small></td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="clear-xs"></div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-4">
                      <!--
                      <div class="form-group no-margin">
                        <button type="button" class="btn btn-outline btn-sm download-selected" disabled><i class="fa fa-download"></i> DESCARGAR SELECCIONADOS</button>
                      </div>
                    -->
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm">
                          <li :class="{disabled: paginador.currentPage === 1}">
                            <a href="#" @click.prevent="goToPrevPage()" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                            </a>
                          </li>
                          <!--
                          <li v-for="i in totalPages" :class="{active: paginador.currentPage === i}" :key="i"><a href="#" @click.prevent="goToPage(i)">{{i}}</a></li>
                          -->
                          <li>
                            <span>Página {{paginador.currentPage}} de {{totalPages}}</span>
                          </li>
                          <li :class="{disabled: paginador.currentPage === totalPages}">
                            <a href="#" @click.prevent="goToNextPage()" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                            </a>
                          </li>
                        <!--
                        <li>
                          <a href="#" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          </a>
                        </li>
                        <li><a href="#">1</a></li>
                        <li><a href="#">2</a></li>
                        <li><a href="#">3</a></li>
                        <li><a href="#">4</a></li>
                        <li><a href="#">5</a></li>
                        <li>
                          <a href="#" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          </a>
                        </li>
                        -->
                        </ul>
                      </nav>
                    </div>
                    <div class="col-xs-12 col-sm-4 text-right">
                      <span class="size-11">Mostrando registros del 1 al 10 de un total de {{entregasFiltradas.length}} registros <template v-if="entregas.length > entregasFiltradas.length">(filtrado de un total de {{entregas.length}} registros)</template></span>
                    </div>
                  </div>
                <div class="hidden">
                  <div id="contenedor-tabla"></div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import _ from 'lodash'
  import moment from 'moment'
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/themes/material_green.css'
  import './../../assets/css/select2.css'
  import $ from 'jquery'
  import 'select2'
  import flatpickr from 'flatpickr'
  import Spanish from 'flatpickr/dist/l10n/es.js'
  import DatePicker from '../Shared/DatePicker'
  import MenuLateral from './MenuLateralAdmin'
  import PHE from 'print-html-element'
  import TableExport from 'tableexport'
  flatpickr.localize(Spanish.es)
  export default {
    components: {
      'date-picker': DatePicker,
      'menu-lateral': MenuLateral
    },
    data () {
      return {
        cambiarA: true,
        entregas: [],
        paginador: {
          pageSize: 10,
          currentPage: 1
        },
        sucursales: [],
        sucursal: {},
        fechaDesde: null,
        fechaHasta: null,
        filtros: {
          fechaDesde: moment().add(-30, 'days').startOf('day').toDate(),
          fechaHasta: moment().endOf('day').toDate(),
          usuario: '-1'
        },
        usuarios: []
      }
    },
    computed: {
      hayConflictoDeFechas () {
        let resultado = false
        const me = this
        if (!me.filtros.fechaDesde || !me.filtros.fechaHasta) {
          return resultado
        }
        if (me.filtros.fechaDesde > me.filtros.fechaHasta) {
          me.$emit('mostrar-notificacion', 'La fecha desde no puede ser mayor a la fecha hasta', 'error')
          // me.filtros.fechaDesde = me.filtros.fechaHasta
          resultado = true
        }
        return resultado
      },
      totalPages () {
        return Math.ceil(this.entregasFiltradas.length / this.paginador.pageSize)
      },
      entregasActivas () {
        const me = this
        let desde = (me.paginador.currentPage - 1) * me.paginador.pageSize
        let hasta = desde + me.paginador.pageSize
        let filtradas = me.entregasFiltradas.filter((entrega, idx) => {
          return idx >= desde && idx < hasta
        })
        return filtradas
      },
      entregasFiltradas () {
        const me = this
        let entregas = me.entregas
        // me.limpiarTodosSeleccionados()
        if (me.filtros.fechaDesde) {
          entregas = entregas.filter((entrega) => {
            return new Date(entrega.fechaEntrega) >= me.filtros.fechaDesde
          })
        }
        if (me.filtros.fechaHasta) {
          entregas = entregas.filter((entrega) => {
            return new Date(entrega.fechaEntrega) <= moment(me.filtros.fechaHasta).endOf('day').toDate()
          })
        }
        if (me.filtros.usuario !== '-1') {
          entregas = entregas.filter((entrega) => {
            return entrega.usuario._id === me.filtros.usuario
          })
        }
        return entregas
      },
      entregasSeleccionadas () {
        const me = this
        let entregas = me.entregas.filter((entrega) => {
          return entrega.seleccionada
        })
        return entregas
      },
      seleccionadosCount () {
        return this.entregas.filter(entrega => entrega.seleccionada).length
      }
    },
    filters: {
      formatearFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY')
      },
      formatearMoneda (value) {
        return '$ ' + parseFloat(value).toFixed(2)
      }
    },
    methods: {
      cambiarSucursal (suc) {
        const me = this
        me.sucursal = suc
        me.cargarPedidos()
      },
      goToPage (pageNumber) {
        const me = this
        if (pageNumber < 0 || pageNumber > me.totalPages) {
          return false
        }
        me.paginador.currentPage = pageNumber
      },
      goToNextPage () {
        const me = this
        if (me.paginador.currentPage >= me.totalPages) {
          return false
        }
        me.paginador.currentPage += 1
      },
      goToPrevPage () {
        const me = this
        if (me.paginador.currentPage < 2) {
          return false
        }
        me.paginador.currentPage -= 1
      },
      cargarPedidos () {
        const me = this
        const datos = {
          desde: me.filtros.fechaDesde,
          hasta: moment(me.filtros.fechaHasta).endOf('day'),
          sucursal: me.sucursal._id
        }
        if (me.filtros.fechaDesde < me.fechaDesde || !me.fechaDesde) {
          me.fechaDesde = me.filtros.fechaDesde
        }
        if (me.filtros.fechaHasta > me.fechaHasta || !me.fechaHasta) {
          me.fechaHasta = me.filtros.fechaHasta
        }
        me.$http.post('/api/users/historialempresa', datos).then(({body}) => {
          const data = body
          me.usuarios = _.sortBy(data[0], 'displayName')
          me.entregas = _.sortBy(data[1], 'numero')
          me.entregas.forEach((entrega) => {
            entrega.seleccionada = false
            let platos = entrega.platos.map((plato) => {
              return `${plato.cantidad}x ${plato.plato.nombre}`
            })
            entrega.platosSerialized = platos.join(' + ')
          })
          $(me.$refs.slEmpleados).select2({
            placeholder: 'Seleccione un usuario',
            allowClear: true
          }).on('change', (e) => {
            me.filtros.usuario = e.target.value
          })
        }, err => console.error(err))
      },
      limpiarTodosSeleccionados () {
        const me = this
        me.entregas.filter((entrega) => {
          entrega.seleccionada = false
        })
      },
      entregasSeleccionadasATablaHtml (entregasSeleccionadas) {
        let tpl = `<table class="table table-striped">
          <thead>
            <tr>
              <th>Número</th>
              <th>Detalle</th>
              <th>Fecha</th>
              <th>Total</th>
              <th>Pedido por</th>
              <th>Pedido para</th>
            </tr>
          </thead>
          <tbody>`
        entregasSeleccionadas.forEach((e) => {
          tpl += `
            <tr>
              <td>${e.numero}</td>
              <td>${e.platosSerialized}</td>
              <td>${moment(e.fechaEntrega).format('DD/MM/YYYY')}</td>
              <td>$ ${parseFloat(e.montoTotal).toFixed(2)}</td>
              <td>${e.usuario.displayName}</td>
              <td>${e.creador.displayName}</td>
            </tr>`
        })
        tpl += `</tbody>
        </table>`
        return tpl
      },
      onChangeFechaHasta (arrDates) {
        this.filtros.fechaHasta = arrDates[0]
      },
      onClickExportar () {
        const me = this
        const entregasSeleccionadas = me.entregasFiltradas.filter(e => e.seleccionada)
        if (entregasSeleccionadas.length > 0) {
          const tpl = me.entregasSeleccionadasATablaHtml(entregasSeleccionadas)
          $('#contenedor-tabla').html(tpl)
          let tableExp = new TableExport(document.getElementById('contenedor-tabla'), {
            exportButtons: false,
            formats: ['xls', 'csv', 'txt', 'xlsx']
          })
          tableExp.types.date.assert = function (v) {
            return false
          }
          tableExp.reset()
          let exportData = tableExp.getExportData()
          const nombreArchivo = `historico${moment().format('YYYYMMDDHHmm')}`
          tableExp.types.date.assert = function (v) {
            return false
          }
          tableExp.export2file(exportData['contenedor-tabla'].xlsx.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', nombreArchivo, '.xlsx')
        } else {
          alert('Debe seleccionar al menos una entrega')
        }
      },
      onClickExportarTodas () {
        const me = this
        if (me.entregasActivas.length < 1) {
          alert('No hay entregas para exportar')
        }
        const tpl = me.entregasSeleccionadasATablaHtml(me.entregasFiltradas)
        $('#contenedor-tabla').html(tpl)
        let tableExp = new TableExport(document.getElementById('contenedor-tabla'), {
          exportButtons: false,
          formats: ['xls', 'csv', 'txt', 'xlsx']
        })
        tableExp.types.date.assert = function (v) {
          return false
        }
        tableExp.reset()
        let exportData = tableExp.getExportData()
        const nombreArchivo = `historico-todas-${moment().format('YYYYMMDDHHmm')}`
        tableExp.types.date.assert = function (v) {
          return false
        }
        tableExp.export2file(exportData['contenedor-tabla'].xlsx.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', nombreArchivo, '.xlsx')
      },
      onClickImprimirTodos () {
        const me = this
        if (me.entregasFiltradas.length < 1) {
          alert('No hay entregas para imprimir')
          return
        }
        const tpl = me.entregasSeleccionadasATablaHtml(me.entregasFiltradas)
        PHE.printHtml(tpl)
      },
      onClickSeleccionarTodos () {
        const me = this
        me.entregasFiltradas.forEach(e => {
          e.seleccionada = me.cambiarA
        })
        me.entregas.push({})
        me.entregas.pop()
        me.cambiarA = !me.cambiarA
      },
      onImprimirSeleccionados (id) {
        const me = this
        const entregasSeleccionadas = me.entregasFiltradas.filter(e => e.seleccionada)
        if (entregasSeleccionadas.length > 0) {
          const tpl = me.entregasSeleccionadasATablaHtml(entregasSeleccionadas)
          PHE.printHtml(tpl)
        } else {
          alert('Debe seleccionar al menos una entrega')
        }
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/users/inithistorialempresa').then(({body}) => {
        const data = body
        console.log(body)
        me.sucursales = data[0]
        me.sucursal = me.sucursales[0]
        me.cargarPedidos()
      }, (err) => {
        console.log(err)
      })
    },
    watch: {
      'filtros.fechaDesde': function (newVal, oldVal) {
        if (oldVal && newVal < oldVal) {
          this.cargarPedidos()
        }
      },
      'filtros.fechaHasta': function (newVal, oldVal) {
        if (oldVal && newVal > oldVal) {
          this.cargarPedidos()
        }
      }
    }
  }
</script>
<style scoped>
  .fa.fa-warning {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// HistorialEmpresa.vue?7efe5ba2